var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDameJidlo = function SvgDameJidlo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M23.193 16.775c-.241 2.789-1.034 4.695-2.731 6.27-1.565 1.456-3.736 2.303-6.255 2.303-3.666 0-5.791-1.362-7.145-3.351-.217-.318-.13-.774.196-1.033l3.727-2.959c.34-.27.801-.218 1.04.1.592.786 1.239 1.245 2.163 1.245 1.168 0 2.032-.97 2.16-2.454l.65-7.516a.867.867 0 0 1 .843-.78h5.141c.505 0 .882.416.838.925l-.627 7.25zM15.044 0H5.782C4.72 0 3.777.874 3.684 1.942L1.238 30.207C1.152 31.193 1.884 32 2.864 32h9.41c10.129 0 17.023-5.875 17.894-15.933l.004-.067.007-.067C31.05 5.875 25.173 0 15.044 0z"
  })));
};
export default SvgDameJidlo;